
  const disciplineOptions = [
    'Empty',
    'Music',
    'Visual Arts',
    'Performing Arts',
    'Literary Arts',
    'Architecture',
    'Sculpture',
    'Painting',
    'Multidisciplinary',
    'Dance',
    'Film',
    'Conceptual Art',
    'Photography',
    'Design and Applied Arts',
  ]

  const pageTypeOptions = [
    {id: 0, title: 'Individual Creator', text: '(i.e. artists, musicians)'},
    {id: 1,  title: 'Organization', text: '(i.e. University, institutions, record labels, organisers)'},
    {id: 2, title: 'Field Professional', text : '(i.e. Services, researchers, musicologists, promoters, managers)'},
    {id: 3, title: 'Space', text: '(i.e. Gallery, concert venue)'},
   ]

  export default {
    disciplineOptions,
    pageTypeOptions
  }